import React from "react";
import {
  Card,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { getTableStyles } from "./tableStyle"; // Ajustá la ruta según tu estructura
import "./tableStyle.css";

export default function HonorarioResultados({ rows, totales, neto }) {
  const tableStyle = process.env.REACT_APP_TABLE_STYLE || "corporate";
  const {
    cardStyle,
    headerStyle,
    rowEvenStyle,
    rowOddStyle,
    totalRowStyle,
    netoStyle,
  } = getTableStyles(tableStyle);

  return (
    <Card style={cardStyle}>
      <div style={{ overflowX: "auto" }}>
        <Table
          sx={{
            minWidth: 650,
            borderCollapse: "separate",
            borderSpacing: "0 4px",
          }}
          aria-label="tabla dinamica"
        >
          <TableHead>
            <TableRow sx={headerStyle}>
              <TableCell size="small" >Concepto</TableCell>
              <TableCell size="small"  align="right">Rem. Sujeta a Retenciones</TableCell>
              <TableCell size="small"  align="right">Rem. Exenta</TableCell>
              <TableCell size="small"  align="right">Retenciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .sort((a, b) => a.order - b.order)
              .map((row, index) => (
                <TableRow
                  key={row.concepto}
                  sx={index % 2 === 0 ? rowEvenStyle : rowOddStyle}
                >
                  <TableCell size="small"  component="th" scope="row">
                    {row.concepto}
                  </TableCell>
                  <TableCell size="small"  align="right">{row.remSujRet?.toFixed(2)}</TableCell>
                  <TableCell size="small"  align="right">{row.remEx?.toFixed(2)}</TableCell>
                  <TableCell size="small"  align="right">{row.descuentos?.toFixed(2)}</TableCell>
                </TableRow>
              ))}
            <TableRow sx={totalRowStyle}>
              <TableCell size="small" >{totales.concepto}</TableCell>
              <TableCell size="small"  align="right">{totales.remSujRet?.toFixed(2)}</TableCell>
              <TableCell size="small"  align="right">{totales.remEx?.toFixed(2)}</TableCell>
              <TableCell size="small"  align="right">{totales.descuentos?.toFixed(2)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell size="small"  />
              <TableCell size="small"  />
              <TableCell size="small"  align="right" sx={netoStyle}>
                Neto a Cobrar
              </TableCell>
              <TableCell size="small"  align="right" sx={netoStyle}>
                {neto?.toFixed(2)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </Card>
  );
}
